(function($) {
  $.googlePlaces = function(element, options) {
    var defaults = {
      placeId: "ChIJnykF9_tw6lIRu-0ZPFH7xG0",
      apiKey: "AIzaSyAFw3vYafCskCqsDRWFWAG-jRDn56HWZq4",
      render: ["reviews"],
      min_rating: 0,
      max_rows: 0,
      rotateTime: false,
      schema: {
        displayElement: "#schema",
        type: "Store",
        beforeText: "Google Users Have Rated",
        middleText: "based on",
        afterText: "ratings and reviews"
      },
      address: { displayElement: "#google-address" },
      phone: { displayElement: "#google-phone" },
      hours: { displayElement: "#google-hours" }
    };

    var plugin = this;
    plugin.settings = {};
    var $element = $(element);

    plugin.init = function() {
      plugin.settings = $.extend(true, {}, defaults, options);

      if (!plugin.settings.placeId || !plugin.settings.apiKey) {
        console.error("googlePlaces plugin: placeId and apiKey are required.");
        return;
      }

      $element.html("<div class='loading'>Loading reviews...</div>");

      initialize_place(function(place) {
        plugin.place_data = place;

        if (plugin.settings.render.indexOf("reviews") > -1 && place.reviews) {
          renderReviews(place.reviews);
          if (!!plugin.settings.rotateTime) {
            initRotation();
          }
        }

        if (plugin.settings.render.indexOf("address") > -1 && place.formattedAddress) {
          renderAddress(capture_element(plugin.settings.address.displayElement), place.formattedAddress);
        }

        if (plugin.settings.render.indexOf("phone") > -1 && place.internationalPhoneNumber) {
          renderPhone(capture_element(plugin.settings.phone.displayElement), place.internationalPhoneNumber);
        }

        if (plugin.settings.render.indexOf("hours") > -1 && place.regularOpeningHours) {
          renderHours(capture_element(plugin.settings.hours.displayElement), place.regularOpeningHours.weekdayDescriptions);
        }

        addSchemaMarkup(capture_element(plugin.settings.schema.displayElement), place);
      });
    };

    var capture_element = function(element) {
      if (element instanceof jQuery) return element;
      if (typeof element === "string") {
        var ele = $(element);
        if (ele.length) return ele;
        console.warn("Element [" + element + "] not found.");
      }
    };

    var initialize_place = async function(callback) {
      try {
        const url = `https://places.googleapis.com/v1/places/${plugin.settings.placeId}`;
        const response = await fetch(url, {
          headers: {
            "X-Goog-Api-Key": plugin.settings.apiKey,
            "X-Goog-FieldMask": "displayName,reviews,formattedAddress,internationalPhoneNumber,regularOpeningHours"
          }
        });
        if (!response.ok) throw new Error("Places API request failed");
        const place = await response.json();
        callback(place);
      } catch (err) {
        console.error("Places API error:", err);
        $element.html("<p>Unable to load reviews at this time.</p>");
      }
    };

    var filter_minimum_rating = function(reviews) {
      return reviews.filter(r => r.rating >= plugin.settings.min_rating);
    };

    var renderReviews = function(reviews) {
      reviews = filter_minimum_rating(reviews);
      var html = "";
      var row_count =
        plugin.settings.max_rows > 0
          ? Math.min(plugin.settings.max_rows, reviews.length)
          : reviews.length;

      for (var i = 0; i < row_count; i++) {
        var r = reviews[i];
        var stars = renderStars(r.rating);
        var date = new Date(r.publishTime).toLocaleDateString();

        html += `
          <div class="review-item review-item-container-${i}">
            <div class="review-meta">
              <span class="review-author">${r.authorAttribution?.displayName || "Anonymous"}</span>
              <span class="review-sep">, </span>
              <span class="review-date">${date}</span>
            </div>
            ${stars}
            <p class="review-text">${r.text?.text || ""}</p>
          </div>`;
      }

      $element.html(html);
    };

    var renderHours = function(element, days) {
      if (element instanceof jQuery && days) {
        var html = "<ul>";
        days.forEach(function(day) {
          html += "<li>" + day + "</li>";
        });
        html += "</ul>";
        element.append(html);
      }
    };

    var renderAddress = function(element, data) {
      if (element instanceof jQuery) element.append(data);
    };

    var renderPhone = function(element, data) {
      if (element instanceof jQuery) element.append(data);
    };

    var initRotation = function() {
      var $reviewEls = $element.children(".review-item");
      var currentIdx = $reviewEls.length > 0 ? 0 : false;

      // Initially mark all as hidden
      $reviewEls.removeClass("active");
      
      if (currentIdx !== false) {
        $($reviewEls[currentIdx]).addClass("active");

        setInterval(function() {
          $reviewEls.removeClass("active"); // hide all
          if (++currentIdx >= $reviewEls.length) currentIdx = 0;
          $($reviewEls[currentIdx]).addClass("active"); // show current
        }, plugin.settings.rotateTime);
      }
  };

    var renderStars = function(rating) {
      var stars = "<div class='review-stars'><ul>";
      for (var i = 0; i < rating; i++) stars += "<li><i class='star'></i></li>";
      for (var i = rating; i < 5; i++) stars += "<li><i class='star inactive'></i></li>";
      stars += "</ul></div>";
      return stars;
    };

    var addSchemaMarkup = function(element, placeData) {
      if (!placeData.reviews) return;
      var reviews = placeData.reviews;
      var total = reviews.reduce((sum, r) => sum + r.rating, 0);
      var avg = total / reviews.length;
      var schema = plugin.settings.schema;

      if (element instanceof jQuery) {
        element.append(
          `<span itemscope itemtype="http://schema.org/${schema.type}">
            <meta itemprop="url" content="${location.origin}">
            ${schema.beforeText} <span itemprop="name">${placeData.displayName?.text || ""}</span>
            <span itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating">
              <span itemprop="ratingValue">${avg.toFixed(2)}</span>/<span itemprop="bestRating">5</span>
              ${schema.middleText} <span itemprop="ratingCount">${reviews.length}</span>
              ${schema.afterText}
            </span>
          </span>`
        );
      }
    };

    plugin.init();
  };

  $.fn.googlePlaces = function(options) {
    return this.each(function() {
      if (undefined === $(this).data("googlePlaces")) {
        var plugin = new $.googlePlaces(this, options);
        $(this).data("googlePlaces", plugin);
      }
    });
  };
})(jQuery);
